import React from 'react';
import { AIIMRForm } from './components/AIIMRForm';
export function App() {
  return <AIIMRForm data-id="element-0" />;
}